var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g3, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g4, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g5, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _g6, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _g7, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMushrooms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 381.6 381.6",
    style: {
      enableBackground: "new 0 0 381.6 381.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{opacity:0.8;fill:#B56A33;}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:#F9AB75;}\n\t.st7{fill:#FFC299;}\n\t.st8{fill:#FFD8BD;}\n\t.st9{fill:url(#SVGID_6_);}\n\t.st10{fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{fill:url(#SVGID_11_);}\n\t.st15{fill:#B56A33;}\n\t.st16{fill:url(#SVGID_12_);}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{fill:url(#SVGID_16_);}\n\t.st21{fill:url(#SVGID_17_);}\n\t.st22{fill:url(#SVGID_18_);}\n\t.st23{fill:url(#SVGID_19_);}\n\t.st24{fill:url(#SVGID_20_);}\n\t.st25{fill:url(#SVGID_21_);}\n\t.st26{fill:url(#SVGID_22_);}\n\t.st27{opacity:0.3;fill:#FFC299;}\n\t.st28{fill:url(#SVGID_23_);}\n\t.st29{fill:url(#SVGID_24_);}\n\t.st30{fill:url(#SVGID_25_);}\n\t.st31{fill:url(#SVGID_26_);}\n\t.st32{fill:url(#SVGID_27_);}\n\t.st33{fill:url(#SVGID_28_);}\n\t.st34{fill:url(#SVGID_29_);}\n\t.st35{fill:url(#SVGID_30_);}\n\t.st36{fill:url(#SVGID_31_);}\n\t.st37{fill:url(#SVGID_32_);}\n\t.st38{fill:url(#SVGID_33_);}\n\t.st39{fill:url(#SVGID_34_);}\n\t.st40{fill:url(#SVGID_35_);}\n\t.st41{fill:url(#SVGID_36_);}\n\t.st42{fill:url(#SVGID_37_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "mushroom"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.6725,
    y1: 60.5635,
    x2: 211.9042,
    y2: 60.5635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.5,43.3c0,0,15,7.9,9.1,22.6c-2.1,5.2-5.3,9.3-12.7,10.7c-12.6,2.3-27.3,1.4-33.3-3 c-6.9-4.9-8.9-13.4-8.9-13.4L201.5,43.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.7235,
    y1: 62.9423,
    x2: 200.7249,
    y2: 62.9423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M177.3,73.3l13.7,0.4c0,0,7.2-1,9.2-7.5c2-6.5-1.3-15.8-15.5-13.5c-14.2,2.3-23,7-21.9,13.5 C163.9,72.7,177.3,73.3,177.3,73.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.17,
    y1: 112.8913,
    x2: 229.0428,
    y2: 97.6123,
    gradientTransform: "matrix(1.0332 0.323 -0.3044 0.9738 4.0768 -111.2795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M200.3,43.8c-14.2-5.5-37.5-4-43.1,9c-4.9,11.3,5.5,22.9,17.7,20.4c0.7-0.1,0.9-2.5,0.2-2.6 c-0.3-0.1-0.6-0.2-0.9-0.3c0,0.2-0.2,0.4-0.4,0.3c-5.3-0.7-7.8-3.7-6.9-9.4c1.9-11.9,19.5-12.3,28.1-8.6c3,1.3,6.9,4.7,6.6,10.3 c-0.1,2.8-1.3,7.4-8.4,8.5c-0.4,0.1-0.5-0.2-0.5-0.5c-1.2,0.3-2.4,0.4-3.6,0.4c-0.8,0,0.1,2.4,0.7,2.4 c8.4-0.3,18.4-1.8,20.7-9.4C211.9,58.9,211.7,48.2,200.3,43.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.2516,
    y1: 116.3514,
    x2: 230.1245,
    y2: 101.0724,
    gradientTransform: "matrix(1.0332 0.323 -0.3044 0.9738 4.0768 -111.2795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M193,71.5c7.2-1,8.3-5.7,8.4-8.5c0.3-5.6-3.6-9-6.6-10.3c-8.6-3.7-26.2-3.4-28.1,8.6 c-0.9,5.7,1.6,8.7,6.9,9.4c0.3,0,0.4-0.2,0.4-0.3c-6.6-2-8.1-7.5-5-10.5c5.6-5.3,25.6-4.3,29-0.3c4.5,5.2,0.2,10-5.7,11.4 C192.5,71.3,192.7,71.6,193,71.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M193,71.5c7.2-1,8.3-5.7,8.4-8.5c0.3-5.6-3.6-9-6.6-10.3c-8.6-3.7-26.2-3.4-28.1,8.6 c-0.9,5.7,1.6,8.7,6.9,9.4c0.3,0,0.4-0.2,0.4-0.3c-6.6-2-8.1-7.5-5-10.5c5.6-5.3,25.6-4.3,29-0.3c4.5,5.2,0.2,10-5.7,11.4 C192.5,71.3,192.7,71.6,193,71.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.5689,
    y1: 57.0389,
    x2: 211.9747,
    y2: 57.0389
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.8,56.4c-1.9-12.8-12.8-15-25.9-16c-10.8-0.8-26.7,1.1-29.9,14c-2.4,9.9,4.7,20.7,18.3,19.1 c0.3,0-0.3-0.9-0.6-0.9c-4.8-0.2-10-1.6-13.4-5.3c-4.1-4.4-4.4-11.6-1.1-16.5c5.4-8.2,17.1-9.1,25.9-8.5c8,0.5,19.2,2.3,23.2,9.3 c5.8,10.2-3.7,22.4-15,20.8c-1-0.1-0.6,0.9,0.4,1.1C203.9,75.1,213.4,67.1,211.8,56.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M177.6,83c0.4,0,0.9,0,1.4,0c-0.5-4.3-0.8-12.9-0.8-12.9S177.3,73.8,177.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M179,56.5C179,56.5,179,56.5,179,56.5c-0.8,0.1-1.6,0.2-2.2,0.3c-2.7,4.9-3.1,17.3-3.2,22.9 c0,2.7,0.2,3.2,1.1,3.2c0.4,0,0.9,0,1.6,0C175.8,74.1,176.6,65.1,179,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M194.3,78.3c-0.1-2.4-0.8-17.3-4.4-21.6c-0.3-0.1-0.6-0.1-0.9-0.2c1.8,8.4,2.2,17.9,1.4,26.6 c1.4,0,2.5,0,3-0.1C194.7,82.8,194.3,80.3,194.3,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M187.4,56.3c-0.2,0-0.3,0-0.5,0c0.9,8.5,1.4,18.3,1,26.8c0.3,0,0.6,0,1,0C189.1,76.2,189.1,61.7,187.4,56.3 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M187,56.3c-2.7-0.2-5.6-0.1-8,0.2c0,0,0,0,0,0c-2.4,8.6-3.2,17.6-2.7,26.5c0.4,0,0.8,0,1.3,0 c-0.2-9.2,0.6-12.9,0.6-12.9s0.3,8.7,0.8,12.9c1.5,0,3.3,0,5.1,0.1c0-6.9,0.5-13.8,0.7-20.7c0-0.4,0.7-0.6,0.8-0.1 c0.3,2.3,0.5,4.6,0.5,6.9c0.1,1.3,0.1,8.7-0.1,13.9c0.8,0,1.5,0,2.2,0C188.3,74.6,187.9,64.8,187,56.3z M179.8,69.4 c-0.2,1-0.9,0.9-0.9-0.3c0-3.2,0.5-7.8,0.8-9.5c0.3-1.6,1-1.5,1-0.1C180.7,61.2,180.1,67.5,179.8,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179.7,59.6c-0.3,1.6-0.8,6.3-0.8,9.5c0,1.2,0.7,1.3,0.9,0.3c0.3-1.9,0.9-8.2,0.9-9.9 C180.7,58.1,180,58,179.7,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M185.9,69.2c0-2.3-0.2-4.6-0.5-6.9c-0.1-0.5-0.8-0.3-0.8,0.1c-0.2,6.9-0.7,13.8-0.7,20.7 c0.6,0,1.2,0,1.8,0C186,78,186,70.6,185.9,69.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M189,56.5c-0.5-0.1-1-0.2-1.6-0.2c1.6,5.4,1.7,19.9,1.5,26.8c0.5,0,1,0,1.4,0C191.2,74.4,190.9,65,189,56.5 z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M203.5,49.3c-2.3-2.5-5.7-3.5-8.1-3.9c-1.2-0.2-1.3,0.5-0.9,0.8c1.3,0.8,4.5,1.1,6.5,2.5 c0.4,0.3,1.9,1.1,2,1.2C203.4,50.1,203.8,49.6,203.5,49.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M200.7,49.7c-0.9-0.4-1.7,0-0.5,0.9c0.6,0.4,1.7,0.9,2.6,1.7c0.3,0.2,0.6-0.1,0.4-0.4 C203.1,51.2,201.5,50,200.7,49.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M167.5,45.8c-1.3,0.1-2.4,0.7-3.9,1.9c-0.9,0.7-2.2,2.2-2.5,3.4c0,0.2,0,0.8,0.8-0.1 c0.6-0.7,1.9-1.8,2.6-2.3c0.9-0.6,2.1-1.6,3-2.1C168.3,46.1,167.8,45.8,167.5,45.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M160.6,53.7c0.3-0.8,0.1-1.2-0.5-0.6c-1.1,1.1-1.4,3.2-1.4,4.8c0,0.5,0.3,0.7,0.6,0.3 C160.1,56.5,160.4,54.2,160.6,53.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M166.3,48.3c-0.4,0.3-1.2,1-0.9,1.4c0.2,0.2,1.9-1,2.2-1.2c0.8-0.4,1.2-0.7,1.2-1.2 C168.7,46.9,167.8,47.2,166.3,48.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.9401,
    y1: 86.6593,
    x2: 183.9401,
    y2: 82.0648
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M173.6,82.4c0,0,0.2,4,9.9,4.3c9.7,0.3,10.8-4.3,10.8-4.3s-3.8-0.1-10.3-0.3C177.5,82,173.6,82.4,173.6,82.4 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.5881,
    y1: 307.5259,
    x2: 156.5915,
    y2: 307.5259,
    gradientTransform: "matrix(-0.6514 0.7587 0.7587 0.6514 -18.367 -178.403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M147.7,109.9c0,0-0.5,18.7-16.3,26.7c-15.8,8-28.5-4.5-28.5-4.5L147.7,109.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.3823,
    y1: 299.7159,
    x2: 155.2374,
    y2: 300.5532,
    gradientTransform: "matrix(-0.6514 0.7587 0.7587 0.6514 -18.367 -178.403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M111.3,105.1c8.3-10.8,14.9-6.4,20.1-6.5c10.6-0.3,16.1-0.3,16.7,5.7c0.4,3.8-0.9,13.8-11.3,22.7 c-10.5,8.9-20.4,8.8-29.8,6C97.6,130.2,102.3,116.9,111.3,105.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 116.9123,
    y1: 298.6708,
    x2: 156.6983,
    y2: 298.6708,
    gradientTransform: "matrix(-0.6514 0.7587 0.7587 0.6514 -18.367 -178.403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M100.3,125.7c0.3-3.3,2.1-6.6,3.5-9.6c1.7-3.4,3.5-6.7,5.6-9.8c3.5-5.1,7.9-9.4,14.4-8.5 c-7.2,0.8-10.9,5.3-14.1,10.3c-3,4.8-6.4,10.3-7.6,15.9c-1.5,7.3,5.6,9.6,11.5,10.1c2.6,0.2,4.9,0.2,7.5-0.2 c3.1-0.5,5.9-1.6,8.8-2.6c0.4-0.1,0.7,0.5,0.3,0.7c-5.5,3.4-13.8,4.2-19.9,3.2C104.8,134.3,99.8,131.8,100.3,125.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.7904,
    y1: 306.7176,
    x2: 136.5215,
    y2: 306.7176,
    gradientTransform: "matrix(0.4408 0.8976 -0.8976 0.4408 346.5977 -131.6658)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112.3,125.4c-1.4-2.2,1.6-4.5,3.6-5.3c4.1-1.9,8.2-3.3,12.1-5.6c1.8-1.1,3.5-2.2,5.2-3.5 c1.3-1,2.6-2.3,4.1-3c2.2-1,4.5,0,5.4,2.3c1.1,2.8-0.7,5.9-2.3,8.2c-4.4,5.9-10.4,9.3-17.5,10.5 C120.1,129.4,114.6,129,112.3,125.4z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M130.2,132.2c-3.9-4-7.7-8.8-10-14c7-2.9,12.5-7,12.5-7s6.3,2.3,8.9,3.4c1.5,0.7,6.1,3,7.5,4 c-0.1,1.4-0.3,5.3-0.8,6.7c-0.9,2.6-2.7,4.5-4.8,6.3c-2.5,2.2-6.8,3.5-10.5,3.9C133.2,134.2,130.9,133,130.2,132.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M130.3,135.7c-2.4-1-4.1-4.6-5.5-6.6c-2.1-3.1-4.4-7-6.1-10.3c0.5-0.2,1-0.4,1.5-0.6c2.3,5.2,6.2,9.9,10,14 c0.7,0.8,3,2,2.9,3.4C132.1,135.7,131.2,135.7,130.3,135.7z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M120.3,115.9c0,0,1.1-0.5,1.1-0.5c2.4,6.9,8.6,12.4,14.1,16.9c0.2,0.2-0.1,1.5-0.3,1.3 C131.8,131.8,121.9,121.1,120.3,115.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M127.1,110.4c5.7,1.5,14.1,4.9,18.5,8.9c-3.8-2.1-14.5-6.9-17.4-8C128.2,111.4,127,110.4,127.1,110.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.5,115.4c5,2.3,10,5.2,13.7,9.3c0.3,0.4-0.3,0.9-0.6,0.6C142.3,121.7,138.3,118.9,133.5,115.4z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M124.5,118.9c-0.2-0.5,0-0.5,0.2-0.2c1.6,2.7,3.9,4.9,6.2,7.1c2.1,2,4.6,3.5,6.7,5.4c0.2,0.2,0,0.4-0.2,0.4 C131.9,129.6,126.4,124.3,124.5,118.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M130,115.2c1.4,0.7,3,1.6,4,2.7c0.1,0.2,0,0.5-0.2,0.3c-1.4-0.7-2.8-1.7-4-2.7 C129.4,115.1,129.6,115,130,115.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.8615,
    y1: 325.9463,
    x2: 128.8615,
    y2: 316.3349,
    gradientTransform: "matrix(-0.6514 0.7587 0.7587 0.6514 -18.367 -178.403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M149.1,118.6c0,0-8.2,5-12.3,8.4c-4.2,3.3-6.5,8.7-6.5,8.7s6.5,2.3,13.7-3.4 C151.3,126.7,149.1,118.6,149.1,118.6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M109.2,125.9c-4.3-5.1,5.8-9.6,9.1-11.2c3.7-1.8,7.2-3.7,10.5-6.2c2.3-1.7,4.3-3.1,7.2-3 c2.4,0.1,5.4,0.8,6.7,3c1.2,2.1,0.7,4.4-0.1,6.5c-0.2-0.1-0.5-0.2-0.7-0.3c0.6-1.9,0.9-4-0.1-5.5c-3.2-3.2-8.5,2.1-11.2,3.8 c-2.9,1.8-5.9,3.3-8.9,4.7c-3,1.4-12.3,4.2-7.7,8.9c2.5,2.5,6.9,1.9,10.2,1.6c0.1,0.2,0.4,0.6,0.6,1c-2.8,0.8-5.7,0.7-8.5,0.1 C114,128.8,110.9,127.9,109.2,125.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.2,127.4c0-0.1,0.1-0.1,0.2-0.1c1,1.2,1.7,2.5,3.1,3.2c1.1,0.6,2.3,0.9,3.5,1.2c0.5,0.1,0.3,0.5,0,0.5 C108.3,132.3,104.5,130.3,104.2,127.4z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M127.9,99.7c1.2,0.1,2.4,0.2,3.6,0.4c2.1,0.2,3.9,0.2,6-0.1c0.5-0.1,0.7,0.2,0.2,0.4 c-1.6,0.7-3.4,0.8-5.1,0.7c-1.4-0.1-3.2-0.4-4.6-0.9C127.6,100,127.3,99.6,127.9,99.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M130.7,102.1c0.8,0.1,2.3,0.2,3.5,0.3c0.2,0,0.3,0.4,0,0.5c-1.1,0.4-2.7,0.2-3.6-0.3 C130.5,102.4,130.5,102,130.7,102.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M112.2,132c0.3-0.1,1.5-0.1,1.8,0.1c0.1,0.1,0.1,0.2,0,0.3c-0.4,0.2-1.4,0.1-1.8-0.2 C112.1,132.1,112.1,132,112.2,132z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.9031,
    y1: 268.9521,
    x2: 323.1355,
    y2: 268.9521,
    gradientTransform: "matrix(0.875 0.4841 -0.4841 0.875 70.3722 -142.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.1,229.1c0,0,9.3,14.2-3,24.1c-4.4,3.5-9.2,5.6-16.3,3.2c-12.1-4.1-24.5-12-27.7-18.7 c-3.6-7.6-1.2-16-1.2-16L222.1,229.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.9543,
    y1: 271.3311,
    x2: 311.956,
    y2: 271.3311,
    gradientTransform: "matrix(0.875 0.4841 -0.4841 0.875 70.3722 -142.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M186.5,243.5l11.8,7c0,0,6.8,2.6,11.7-2.1c4.9-4.7,6.5-14.5-7-19.3c-13.5-4.8-23.5-5-25.7,1.2 C175.1,236.5,186.5,243.5,186.5,243.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.8834,
    y1: 275.3204,
    x2: 384.7557,
    y2: 260.0416,
    gradientTransform: "matrix(0.7477 0.7828 -0.7378 0.7047 127.67 -238.1381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M220.8,228.9c-9.8-11.7-30.9-21.6-42.1-13c-9.7,7.5-6.3,22.7,5.6,26.4c0.6,0.2,2-1.8,1.5-2.2 c-0.3-0.2-0.5-0.5-0.7-0.7c-0.1,0.2-0.3,0.2-0.6,0.1c-4.3-3.2-5-7-1.5-11.6c7.4-9.5,23-1.3,28.7,6.1c2,2.6,3.8,7.5,0.8,12.2 c-1.5,2.4-4.7,5.9-11.5,3.3c-0.3-0.1-0.4-0.5-0.2-0.7c-1.1-0.3-2.3-0.8-3.3-1.4c-0.7-0.4-1.1,2.1-0.6,2.4 c7.5,3.8,17,7.3,22.7,1.8C223.8,247.8,228.7,238.3,220.8,228.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.9652,
    y1: 278.7804,
    x2: 385.8374,
    y2: 263.5016,
    gradientTransform: "matrix(0.7477 0.7828 -0.7378 0.7047 127.67 -238.1381)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M201.1,249.6c6.8,2.6,10-1,11.5-3.3c2.9-4.7,1.2-9.6-0.8-12.2c-5.7-7.4-21.3-15.7-28.7-6.1 c-3.5,4.6-2.8,8.4,1.5,11.6c0.2,0.2,0.4,0.1,0.6-0.1c-4.8-4.9-3.5-10.5,0.7-11.6c7.5-1.9,24.4,8.7,25.5,13.8 c1.4,6.7-4.7,8.9-10.5,7.3C200.7,249.2,200.7,249.5,201.1,249.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M201.1,249.6c6.8,2.6,10-1,11.5-3.3c2.9-4.7,1.2-9.6-0.8-12.2c-5.7-7.4-21.3-15.7-28.7-6.1 c-3.5,4.6-2.8,8.4,1.5,11.6c0.2,0.2,0.4,0.1,0.6-0.1c-4.8-4.9-3.5-10.5,0.7-11.6c7.5-1.9,24.4,8.7,25.5,13.8 c1.4,6.7-4.7,8.9-10.5,7.3C200.7,249.2,200.7,249.5,201.1,249.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.7995,
    y1: 265.4278,
    x2: 323.206,
    y2: 265.4278,
    gradientTransform: "matrix(0.875 0.4841 -0.4841 0.875 70.3722 -142.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M224.8,245.5c4.5-12.1-4-19.3-14.9-26.5c-9.1-5.9-23.9-11.9-32.9-2.2c-6.9,7.5-5.9,20.4,6.7,25.6 c0.3,0.1,0.2-1-0.1-1.1c-4.1-2.5-8-6.3-9.1-11.1c-1.4-5.9,1.8-12.2,7-15c8.7-4.6,19.3,0.3,26.7,5.1c6.8,4.3,15.7,11.3,15.8,19.4 c0.1,11.7-14.1,17.8-23.2,10.9c-0.8-0.6-0.9,0.5-0.2,1.1C208.9,258,221.1,255.7,224.8,245.5z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M182,252.2c0.4,0.2,0.8,0.4,1.2,0.7c1.6-4,5.6-11.7,5.6-11.7S186.2,244.1,182,252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.1,229.7C196.1,229.7,196.1,229.7,196.1,229.7c-0.7-0.3-1.5-0.6-2.1-0.8c-4.7,3-11.1,13.6-13.9,18.5 c-1.3,2.3-1.4,2.9-0.6,3.3c0.3,0.2,0.8,0.4,1.4,0.8C184.8,243.6,189.8,236.1,196.1,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M198.9,256.2c1.1-2.1,7.7-15.5,6.6-21c-0.2-0.2-0.5-0.4-0.7-0.6c-2.5,8.3-6.8,16.7-11.7,23.9 c1.2,0.7,2.2,1.2,2.7,1.3C197.1,260.3,198,258,198.9,256.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M203.6,233.6c-0.1-0.1-0.2-0.2-0.4-0.3c-3.3,7.9-7.7,16.7-12.1,24c0.3,0.2,0.6,0.3,0.8,0.5 C195.4,251.8,202.4,239.1,203.6,233.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M203.2,233.4c-2.3-1.5-4.8-2.8-7.1-3.7c0,0,0,0,0,0c-6.2,6.4-11.3,13.9-15.2,21.9c0.3,0.2,0.7,0.4,1.1,0.6 c4.3-8.1,6.8-11,6.8-11s-4,7.7-5.6,11.7c1.3,0.8,2.9,1.6,4.4,2.5c3.3-6,7.1-11.9,10.6-17.8c0.2-0.4,0.9-0.1,0.7,0.3 c-0.9,2.2-1.8,4.3-2.9,6.3c-0.6,1.2-4.2,7.7-6.8,12.1c0.7,0.4,1.3,0.7,1.9,1.1C195.5,250,199.8,241.3,203.2,233.4z  M190.6,241.3c-0.6,0.8-1.2,0.3-0.6-0.7c1.5-2.8,4.2-6.6,5.3-7.9c1-1.3,1.5-0.8,0.9,0.3C195.3,234.6,191.8,239.9,190.6,241.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M195.2,232.8c-1.1,1.3-3.7,5.1-5.3,7.9c-0.6,1,0,1.4,0.6,0.7c1.2-1.5,4.7-6.7,5.6-8.2 C196.8,231.9,196.2,231.5,195.2,232.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196,244.2c1.1-2,2.1-4.1,2.9-6.3c0.2-0.4-0.5-0.7-0.7-0.3c-3.5,5.9-7.3,11.8-10.6,17.8 c0.5,0.3,1.1,0.6,1.6,0.9C191.8,251.9,195.4,245.4,196,244.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M204.8,234.6c-0.4-0.3-0.8-0.6-1.3-0.9c-1.2,5.5-8.1,18.2-11.6,24.2c0.4,0.2,0.8,0.5,1.2,0.7 C198.1,251.3,202.4,242.8,204.8,234.6z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M221.1,235.3c-0.8-3.3-3.3-5.8-5.2-7.3c-0.9-0.7-1.4-0.2-1.1,0.3c0.8,1.3,3.4,3.1,4.5,5.3 c0.2,0.4,1.1,1.9,1.2,2C220.6,235.9,221.2,235.7,221.1,235.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M218.4,234.3c-0.6-0.8-1.5-0.8-0.9,0.5c0.3,0.6,1,1.6,1.5,2.7c0.2,0.4,0.5,0.2,0.6-0.2 C219.7,236.8,218.9,234.9,218.4,234.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M191.2,214.8c-1.2-0.6-2.5-0.5-4.4-0.2c-1.2,0.2-3,0.9-3.8,1.7c-0.1,0.2-0.4,0.7,0.7,0.3 c0.9-0.3,2.5-0.7,3.4-0.7c1-0.1,2.6-0.4,3.6-0.4C191.7,215.5,191.5,214.9,191.2,214.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M181.4,218.3c0.7-0.6,0.7-1-0.2-0.7c-1.5,0.5-2.8,2.2-3.5,3.6c-0.2,0.5-0.1,0.8,0.4,0.5 C179.6,220.6,180.9,218.7,181.4,218.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.9,216.4c-0.4,0.1-1.6,0.3-1.4,0.8c0.1,0.2,2.2,0,2.5,0c0.9,0,1.4-0.1,1.6-0.5 C191.8,216.3,190.8,216.1,188.9,216.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.1714,
    y1: 295.0483,
    x2: 295.1714,
    y2: 290.4539,
    gradientTransform: "matrix(0.875 0.4841 -0.4841 0.875 70.3722 -142.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M178.8,249.7c0,0-1.8,3.6,6.6,8.5c8.3,4.9,11.5,1.5,11.5,1.5s-3.3-2-8.9-5.2 C182.5,251.3,178.8,249.7,178.8,249.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.95,
    y1: 269.9248,
    x2: 100.9799,
    y2: 269.9248,
    gradientTransform: "matrix(0.2287 -0.9735 0.9735 0.2287 -183.9274 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M100.1,295.1c0,0,8.9-1.2,13.4-9.7c6.3-12-3.4-27.2-13.7-31c-10.3-3.9-16.7-2.7-16.7-2.7L100.1,295.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.5481,
    y1: 264.1162,
    x2: 100.4284,
    y2: 264.7728,
    gradientTransform: "matrix(0.2287 -0.9735 0.9735 0.2287 -183.9274 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M71.1,270c0.8,8.6,13.8,30.3,32.8,22.4c4.6-1.9,8.3-7.8,8.9-13.3c0.6-5.9-3.6-11.5-7-15.3 c-4.1-4.6-9.8-8.9-15.3-11.3C80.2,247.8,70.2,259.2,71.1,270z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8825,
    y1: 266.204,
    x2: 96.1208,
    y2: 266.204,
    gradientTransform: "matrix(0.2287 -0.9735 0.9735 0.2287 -183.9274 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M86.6,257.3c-9.5,3.5-0.1,15.1,4.7,18.5c3.2,2.3,8.7,5.1,12.7,3.7c2.1-0.7,3.2-2.7,3.1-4.6 c0.1-1.1,0-2.3-0.5-3.4c-1-2.2-2.8-4.1-4.3-6c-1.5-2-3.1-4-5-5.6C94.3,257.3,90.4,255.9,86.6,257.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.8685,
    y1: 264.4025,
    x2: 100.8482,
    y2: 264.4025,
    gradientTransform: "matrix(0.2287 -0.9735 0.9735 0.2287 -183.9274 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M75.9,255.2c-2.7,2.9-5,6.9-5.7,10.9c-0.6,3.8,0.4,7.4,2.1,10.8c3.3,6.6,8.5,14.7,15.8,17.4 c7.5,2.8,16.4,1.4,21.5-4.9c2.8-3.4,4.2-7.6,3.7-12.2c-0.4-3.5-2.2-8.3-5.2-11.1c-0.6-0.6-1.3-0.1-0.7,0.4 c2.9,2.7,4.7,7.6,4.9,11.4c0.3,5.1-2.7,10.4-6.7,13.2c-3.9,2.8-9.1,3-13.8,2.2c-4.5-0.8-8.8-3.1-11.6-6.6 c-5.2-6.3-11-15.1-7.9-23.4c1.6-4.2,4.5-8.7,8.9-10.3c3.9-1.4,7.9-0.7,11.5,1.3c0.4,0.2,1.2-0.1,0.9-0.4 C88.8,249.5,80.1,250.7,75.9,255.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.8,263.1c1.1-2.4,3.2-8.4,4.8-12.7c-0.8-0.2-1.7-0.5-2.4-0.6c-1.5-0.4-3.7-1.6-5.1-0.7 c-1.5,1-2.4,3.7-3,5.3c-2,6.2-5,12.6-6.4,15.7c1.3,2.1,5.1,5.9,8.7,7.6c4.3-3.1,17.1-16.3,16.1-23.3c-0.1-0.9-1.8-1.9-4.1-2.7 c-0.7,3.4-1.9,6.7-3.4,9.7c-1,2-2.2,3.9-3.6,5.6c-1.5,1.8-3.5,3.2-5.1,5c1-2.1,5.7-6.4,7.6-10.6c1.5-3.3,2.3-6.7,3.2-10.1 c-0.5-0.2-1-0.3-1.5-0.5c-1.4,4.4-4.3,11.3-5.5,12.9C97.8,264,97.4,263.9,97.8,263.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.8,263.1c-0.4,0.8,0,0.9,0.3,0.5c1.2-1.6,4.1-8.5,5.5-12.9c-0.3-0.1-0.7-0.2-1-0.3 C101,254.7,98.8,260.7,97.8,263.1z"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M101.9,261.3c-1.9,4.2-6.6,8.5-7.6,10.6c1.6-1.7,3.6-3.1,5.1-5c1.4-1.7,2.6-3.6,3.6-5.6 c1.5-3,2.7-6.3,3.4-9.7c-0.4-0.2-0.9-0.3-1.3-0.5C104.1,254.6,103.4,258,101.9,261.3z"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M107.3,252.1c0.8,6-2.7,11.2-6.4,15.4c-2.8,3.1-7.1,6.6-8.4,10.7c0,0.1,0.1,0.1,0.1,0.1 c0.3-0.4,0.6-0.7,1-1.1c0,0,0,0,0,0.1c0.1,0.2,0.3,0.3,0.4,0.5c0,0.1-0.1,0.3-0.1,0.6c0,0.1,0.1,0.1,0.1,0.1 c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.3,0,0.4-0.1c0.1,0,0.2,0,0.2-0.1c4.6-4.9,8.3-8.8,12.1-13.9c1.3-1.8,4.1-5.5,4.1-7.8 C111,255.1,109.1,252.8,107.3,252.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.405,
    y1: 281.053,
    x2: 90.405,
    y2: 267.8549,
    gradientTransform: "matrix(0.2287 -0.9735 0.9735 0.2287 -183.9274 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M95.4,278.2c0,0,12.3-6.8,16.2-16.5c2.8-7.1-4.2-9.6-4.2-9.6s2,2,2.3,4.1c0.3,2.1-0.9,4.3-3.4,8.2 c-2.5,3.8-11.9,13.3-11.9,13.3L95.4,278.2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.5,262.9c-1.3,2.7-2.5,5.8-4.5,8.1c0.3,0.3,0.6,0.5,0.8,0.8c1.8-2,2.8-4.8,3.8-7 c1.9-4.3,4.2-8.8,5.1-13.4C92.6,256.1,91.3,259.1,89.5,262.9z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M84.6,257.1c-0.1,0-0.1,0.1-0.2,0.1c-2,1.2-3.5,3.3-3.8,5.4c-0.9,6,2.4,11.8,6.8,15.5 c4.2,3.5,10,7,15.4,4.3c5.3-2.6,6.2-7.9,3.1-12.5c-0.3,0.3-0.4,0.5-0.6,0.6c1.6,3.5,1.5,6.1,0.2,7.4c-1.6,1.7-4.4,1.1-6.4,0.6 c-3.7-0.9-6.9-3-9.7-5.5c-2.6-2.4-5.1-5.4-5.9-9c-0.6-2.7,0-5.6,3-6.5c1.5-0.4,2.9-0.3,4.2,0.3c0.1-0.1,0.2-0.7,0.4-1 C89.1,255.5,86.6,255.9,84.6,257.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M96.5,251c-1.9,5.1-3.3,9.1-4.8,11.7c-0.3,0.6,0,0.7,0.4,0.3c2.2-2.5,4.6-9.5,5.1-11.7 C97.4,250.6,96.7,250.3,96.5,251z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M74.7,275.7c0.8,1.2,2.2,2,3.6,0.7c1.5-1.4,1.1-4.1,0.7-5.7c-0.5-2.3-1.6-5-1.1-7.3 c0.2-1.1,0.7-3.1-0.4-3.5C74.9,258.9,70.7,269.8,74.7,275.7z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M73.9,272.2c0.3,1.4,1,2.8,2.1,3.7c0.3,0.3,0.8,0.3,0.4-0.2c-0.9-1.2-1.3-2.7-1.8-4.2 C74.2,270.4,73.6,270.9,73.9,272.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.4,290.4c-2.2,0.1-4,1.1-6.1,1c-2.1-0.1-4.2-0.3-6.2-1c-1.1-0.4-1.6,0.3-0.3,0.8c4,1.6,9.1,1.8,12.9,0.4 C102.7,291.2,102.1,290.3,101.4,290.4z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M104.9,288.9c-0.5,0.3-1.7,0.9-1.3,1.3c0.5,0.4,1.4-0.3,1.9-0.6c0.5-0.3,1.7-1.4,1.6-2 C107,286.9,105.6,288.5,104.9,288.9z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M104.3,284c-1.1,0.2-2.2,0.3-3.2,0.5c-1.3,0.1-2.8,0.6-3.3,1.9c-0.4,1,0.3,2.8,3.5,2.5 c1.6-0.2,3.3-1.1,4.4-2.3c0.6-0.6,1.6-1.8,0.6-2.5C105.6,283.8,104.8,283.9,104.3,284z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.5,273.5C83,279,90,284,95.9,284.3c0.2,0,0.6-0.3-0.2-0.4c-2.7-0.6-5.1-1.5-7.4-3.1 c-2.7-1.9-5.3-4.5-6.5-7.6C81.5,272.4,81.4,272.8,81.5,273.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 58.2747,
    y1: 400.9987,
    x2: 99.7943,
    y2: 400.9987,
    gradientTransform: "matrix(-0.2287 -0.9735 -0.9735 0.2287 626.3757 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M215,327.7c0,0-9.2-1.2-13.9-10.1c-6.6-12.5,3.5-28.2,14.3-32.2c10.7-4,17.3-2.8,17.3-2.8L215,327.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.858,
    y1: 394.9739,
    x2: 99.2223,
    y2: 395.655,
    gradientTransform: "matrix(-0.2287 -0.9735 -0.9735 0.2287 626.3757 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M245.1,301.7c-0.8,8.9-14.3,31.4-34,23.2c-4.8-2-8.6-8.1-9.2-13.8c-0.6-6.2,3.7-11.9,7.2-15.9 c4.2-4.8,10.1-9.2,15.8-11.8C235.7,278.7,246.1,290.5,245.1,301.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.763,
    y1: 397.1394,
    x2: 94.7545,
    y2: 397.1394,
    gradientTransform: "matrix(-0.2287 -0.9735 -0.9735 0.2287 626.3757 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M229.1,288.5c9.8,3.6,0.1,15.6-4.8,19.1c-3.3,2.4-9,5.3-13.2,3.9c-2.1-0.7-3.3-2.8-3.2-4.7 c-0.2-1.2,0-2.4,0.5-3.6c1-2.3,2.9-4.3,4.4-6.3c1.6-2,3.2-4.1,5.2-5.8C221.1,288.6,225.2,287.1,229.1,288.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.1158,
    y1: 395.2709,
    x2: 99.6578,
    y2: 395.2709,
    gradientTransform: "matrix(-0.2287 -0.9735 -0.9735 0.2287 626.3757 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M240.2,286.4c2.8,3,5.2,7.2,5.9,11.3c0.7,3.9-0.4,7.7-2.2,11.2c-3.4,6.9-8.8,15.2-16.4,18 c-7.8,2.9-17,1.4-22.3-5.1c-2.9-3.6-4.4-7.9-3.8-12.6c0.5-3.7,2.3-8.6,5.4-11.5c0.6-0.6,1.4-0.1,0.7,0.4 c-3,2.8-4.9,7.9-5.1,11.9c-0.4,5.3,2.8,10.8,7,13.7c4.1,2.9,9.5,3.1,14.3,2.2c4.7-0.8,9.1-3.2,12-6.8 c5.4-6.5,11.4-15.6,8.1-24.3c-1.7-4.4-4.6-9-9.2-10.7c-4.1-1.5-8.2-0.7-11.9,1.3c-0.4,0.2-1.2-0.1-0.9-0.4 C226.8,280.4,235.8,281.7,240.2,286.4z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M217.5,294.5c-1.1-2.5-3.3-8.7-5-13.2c0.9-0.3,1.7-0.5,2.5-0.7c1.5-0.4,3.9-1.7,5.3-0.7 c1.6,1,2.5,3.8,3.1,5.5c2.1,6.4,5.2,13,6.6,16.3c-1.4,2.2-5.3,6.2-9,7.9c-4.5-3.2-17.7-16.9-16.7-24.2c0.1-0.9,1.9-1.9,4.2-2.8 c0.7,3.5,2,6.9,3.5,10c1,2.1,2.3,4,3.7,5.8c1.6,1.9,3.6,3.3,5.3,5.1c-1-2.2-5.9-6.7-7.9-11c-1.6-3.4-2.4-6.9-3.3-10.5 c0.5-0.2,1-0.3,1.5-0.5c1.5,4.6,4.5,11.7,5.7,13.4C217.5,295.5,217.9,295.4,217.5,294.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M217.5,294.5c0.4,0.9,0,1-0.3,0.6c-1.2-1.7-4.2-8.8-5.7-13.4c0.3-0.1,0.7-0.2,1-0.3 C214.2,285.8,216.4,292.1,217.5,294.5z"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M213.3,292.7c2,4.3,6.9,8.8,7.9,11c-1.7-1.8-3.7-3.2-5.3-5.1c-1.5-1.8-2.7-3.7-3.7-5.8 c-1.5-3.1-2.8-6.6-3.5-10c0.4-0.2,0.9-0.3,1.4-0.5C210.9,285.7,211.7,289.3,213.3,292.7z"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M207.6,283.1c-0.8,6.2,2.8,11.6,6.7,16c2.9,3.3,7.3,6.8,8.7,11.1c0,0.1-0.1,0.1-0.1,0.1 c-0.3-0.4-0.7-0.8-1-1.1c0,0,0,0,0,0.1c-0.1,0.2-0.3,0.3-0.4,0.5c0,0.1,0.1,0.3,0.1,0.6c0,0.1-0.1,0.1-0.1,0.1 c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.1-0.3,0-0.4-0.1c-0.1,0-0.2,0-0.3-0.1c-4.8-5.1-8.6-9.1-12.5-14.5c-1.3-1.9-4.3-5.7-4.2-8.1 C203.7,286.2,205.7,283.9,207.6,283.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.826,
    y1: 412.541,
    x2: 88.826,
    y2: 398.8517,
    gradientTransform: "matrix(-0.2287 -0.9735 -0.9735 0.2287 626.3757 290.9726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M220,310.2c0,0-12.7-7.1-16.8-17.1c-2.9-7.3,4.4-9.9,4.4-9.9s-2,2.1-2.4,4.3c-0.4,2.2,1,4.5,3.6,8.5 c2.5,4,12.3,13.8,12.3,13.8L220,310.2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M226.1,294.4c1.3,2.8,2.5,6,4.7,8.4c-0.3,0.3-0.6,0.5-0.9,0.8c-1.8-2.1-2.9-4.9-4-7.3 c-2-4.4-4.4-9.2-5.3-13.9C222.8,287.3,224.2,290.4,226.1,294.4z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M231.2,288.4c0.1,0,0.1,0.1,0.2,0.1c2,1.3,3.6,3.4,3.9,5.6c0.9,6.2-2.4,12.2-7.1,16.1 c-4.4,3.7-10.4,7.2-16,4.5c-5.5-2.7-6.5-8.2-3.2-13c0.3,0.3,0.4,0.5,0.6,0.7c-1.7,3.6-1.5,6.4-0.2,7.7c1.6,1.7,4.6,1.2,6.6,0.7 c3.8-0.9,7.2-3.1,10-5.7c2.7-2.5,5.3-5.6,6.1-9.3c0.6-2.8,0-5.8-3.1-6.8c-1.5-0.5-3-0.3-4.3,0.3c-0.1-0.1-0.3-0.8-0.4-1.1 C226.5,286.7,229.1,287.1,231.2,288.4z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M218.8,282c2,5.3,3.4,9.4,5,12.2c0.4,0.6,0,0.8-0.4,0.3c-2.3-2.6-4.7-9.9-5.3-12.1 C217.9,281.5,218.6,281.2,218.8,282z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M241.4,307.6c-0.9,1.2-2.3,2.1-3.7,0.7c-1.6-1.5-1.1-4.3-0.8-5.9c0.5-2.4,1.7-5.1,1.1-7.6 c-0.2-1.1-0.8-3.2,0.4-3.6C241.2,290.2,245.6,301.6,241.4,307.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M242.3,304c-0.3,1.5-1,2.9-2.2,3.8c-0.3,0.3-0.8,0.3-0.4-0.2c1-1.2,1.4-2.8,1.9-4.3 C241.9,302.1,242.6,302.7,242.3,304z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M213.8,322.8c2.3,0.1,4.1,1.1,6.3,1c2.2-0.1,4.4-0.3,6.5-1c1.2-0.4,1.7,0.3,0.3,0.9 c-4.1,1.7-9.4,1.9-13.4,0.4C212.4,323.6,213,322.8,213.8,322.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M210.1,321.4c0.5,0.3,1.8,1,1.3,1.3c-0.5,0.4-1.5-0.3-2-0.6c-0.5-0.3-1.7-1.5-1.6-2.1 C208,319.3,209.4,320.9,210.1,321.4z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M210.8,316.2c1.1,0.2,2.2,0.4,3.4,0.5c1.4,0.1,2.9,0.6,3.5,2c0.4,1.1-0.3,2.9-3.6,2.6 c-1.6-0.2-3.4-1.2-4.5-2.4c-0.6-0.7-1.6-1.9-0.6-2.6C209.4,316,210.2,316.1,210.8,316.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M234.3,305.3c-1.5,5.7-8.8,10.9-14.9,11.2c-0.2,0-0.6-0.3,0.2-0.5c2.8-0.6,5.3-1.5,7.7-3.2 c2.8-2,5.5-4.7,6.7-7.9C234.3,304.2,234.5,304.6,234.3,305.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.5814,
    y1: 263.9006,
    x2: 334.101,
    y2: 263.9006,
    gradientTransform: "matrix(-0.2287 0.9735 -0.9735 -0.2287 626.3757 -121.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M294.9,101c0,0-9.2,1.2-13.9,10.1c-6.6,12.5,3.5,28.2,14.3,32.2c10.7,4,17.3,2.8,17.3,2.8L294.9,101z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.1647,
    y1: 257.8758,
    x2: 333.529,
    y2: 258.5569,
    gradientTransform: "matrix(-0.2287 0.9735 -0.9735 -0.2287 626.3757 -121.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M325,127.1c-0.8-8.9-14.3-31.4-34-23.2c-4.8,2-8.6,8.1-9.2,13.8c-0.6,6.2,3.7,11.9,7.2,15.9 c4.2,4.8,10.1,9.2,15.8,11.8C315.6,150,326,138.3,325,127.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.0696,
    y1: 260.0413,
    x2: 329.0611,
    y2: 260.0413,
    gradientTransform: "matrix(-0.2287 0.9735 -0.9735 -0.2287 626.3757 -121.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M309,140.2c9.8-3.6,0.1-15.6-4.8-19.1c-3.3-2.4-9-5.3-13.2-3.9c-2.1,0.7-3.3,2.8-3.2,4.7 c-0.2,1.2,0,2.4,0.5,3.6c1,2.3,2.9,4.3,4.4,6.3c1.6,2,3.2,4.1,5.2,5.8C301,140.1,305.1,141.6,309,140.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.4225,
    y1: 258.1728,
    x2: 333.9644,
    y2: 258.1728,
    gradientTransform: "matrix(-0.2287 0.9735 -0.9735 -0.2287 626.3757 -121.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M320.1,142.3c2.8-3,5.2-7.2,5.9-11.3c0.7-3.9-0.4-7.7-2.2-11.2c-3.4-6.9-8.8-15.2-16.4-18 c-7.8-2.9-17-1.4-22.3,5.1c-2.9,3.6-4.4,7.9-3.8,12.6c0.5,3.7,2.3,8.6,5.4,11.5c0.6,0.6,1.4,0.1,0.7-0.4 c-3-2.8-4.9-7.9-5.1-11.9c-0.4-5.3,2.8-10.8,7-13.7c4.1-2.9,9.5-3.1,14.3-2.2c4.7,0.8,9.1,3.2,12,6.8 c5.4,6.5,11.4,15.6,8.1,24.3c-1.7,4.4-4.6,9-9.2,10.7c-4.1,1.5-8.2,0.7-11.9-1.3c-0.4-0.2-1.2,0.1-0.9,0.4 C306.6,148.3,315.7,147,320.1,142.3z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M297.4,134.2c-1.1,2.5-3.3,8.7-5,13.2c0.9,0.3,1.7,0.5,2.5,0.7c1.5,0.4,3.9,1.7,5.3,0.7 c1.6-1,2.5-3.8,3.1-5.5c2.1-6.4,5.2-13,6.6-16.3c-1.4-2.2-5.3-6.2-9-7.9c-4.5,3.2-17.7,16.9-16.7,24.2c0.1,0.9,1.9,1.9,4.2,2.8 c0.7-3.5,2-6.9,3.5-10c1-2.1,2.3-4,3.7-5.8c1.6-1.9,3.6-3.3,5.3-5.1c-1,2.2-5.9,6.7-7.9,11c-1.6,3.4-2.4,6.9-3.3,10.5 c0.5,0.2,1,0.3,1.5,0.5c1.5-4.6,4.5-11.7,5.7-13.4C297.4,133.2,297.8,133.3,297.4,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M297.4,134.2c0.4-0.9,0-1-0.3-0.6c-1.2,1.7-4.2,8.8-5.7,13.4c0.3,0.1,0.7,0.2,1,0.3 C294.1,142.9,296.3,136.6,297.4,134.2z"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.1,136.1c2-4.3,6.9-8.8,7.9-11c-1.7,1.8-3.7,3.2-5.3,5.1c-1.5,1.8-2.7,3.7-3.7,5.8 c-1.5,3.1-2.8,6.6-3.5,10c0.4,0.2,0.9,0.3,1.4,0.5C290.8,143,291.6,139.5,293.1,136.1z"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M287.5,145.6c-0.8-6.2,2.8-11.6,6.7-16c2.9-3.3,7.3-6.8,8.7-11.1c0-0.1-0.1-0.1-0.1-0.1 c-0.3,0.4-0.7,0.8-1,1.1c0,0,0,0,0-0.1c-0.1-0.2-0.3-0.3-0.4-0.5c0-0.1,0.1-0.3,0.1-0.6c0-0.1-0.1-0.1-0.1-0.1 c-0.1,0.1-0.2,0.2-0.3,0.4c-0.1-0.1-0.3,0-0.4,0.1c-0.1,0-0.2,0-0.3,0.1c-4.8,5.1-8.6,9.1-12.5,14.5c-1.3,1.9-4.3,5.7-4.2,8.1 C283.6,142.5,285.6,144.8,287.5,145.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.1326,
    y1: 275.4429,
    x2: 323.1326,
    y2: 261.7536,
    gradientTransform: "matrix(-0.2287 0.9735 -0.9735 -0.2287 626.3757 -121.7061)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M299.9,118.5c0,0-12.7,7.1-16.8,17.1c-2.9,7.3,4.4,9.9,4.4,9.9s-2-2.1-2.4-4.3c-0.4-2.2,1-4.5,3.6-8.5 c2.5-4,12.3-13.8,12.3-13.8L299.9,118.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.9,134.3c1.3-2.8,2.5-6,4.7-8.4c-0.3-0.3-0.6-0.5-0.9-0.8c-1.8,2.1-2.9,4.9-4,7.3 c-2,4.4-4.4,9.2-5.3,13.9C302.7,141.4,304.1,138.3,305.9,134.3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M311.1,140.4c0.1,0,0.1-0.1,0.2-0.1c2-1.3,3.6-3.4,3.9-5.6c0.9-6.2-2.4-12.2-7.1-16.1 c-4.4-3.7-10.4-7.2-16-4.5c-5.5,2.7-6.5,8.2-3.2,13c0.3-0.3,0.4-0.5,0.6-0.7c-1.7-3.6-1.5-6.4-0.2-7.7c1.6-1.7,4.6-1.2,6.6-0.7 c3.8,0.9,7.2,3.1,10,5.7c2.7,2.5,5.3,5.6,6.1,9.3c0.6,2.8,0,5.8-3.1,6.8c-1.5,0.5-3,0.3-4.3-0.3c-0.1,0.1-0.3,0.8-0.4,1.1 C306.3,142,308.9,141.7,311.1,140.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M298.7,146.7c2-5.3,3.4-9.4,5-12.2c0.4-0.6,0-0.8-0.4-0.3c-2.3,2.6-4.7,9.9-5.3,12.1 C297.8,147.2,298.4,147.5,298.7,146.7z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M321.3,121.1c-0.9-1.2-2.3-2.1-3.7-0.7c-1.6,1.5-1.1,4.3-0.8,5.9c0.5,2.4,1.7,5.1,1.1,7.6 c-0.2,1.1-0.8,3.2,0.4,3.6C321.1,138.5,325.5,127.2,321.3,121.1z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M322.2,124.7c-0.3-1.5-1-2.9-2.2-3.8c-0.3-0.3-0.8-0.3-0.4,0.2c1,1.2,1.4,2.8,1.9,4.3 C321.8,126.6,322.5,126,322.2,124.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M293.7,105.9c2.3-0.1,4.1-1.1,6.3-1c2.2,0.1,4.4,0.3,6.5,1c1.2,0.4,1.7-0.3,0.3-0.9 c-4.1-1.7-9.4-1.9-13.4-0.4C292.2,105.1,292.9,105.9,293.7,105.9z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M290,107.4c0.5-0.3,1.8-1,1.3-1.3c-0.5-0.4-1.5,0.3-2,0.6c-0.5,0.3-1.7,1.5-1.6,2.1 C287.8,109.5,289.2,107.8,290,107.4z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M290.6,112.5c1.1-0.2,2.2-0.4,3.4-0.5c1.4-0.1,2.9-0.6,3.5-2c0.4-1.1-0.3-2.9-3.6-2.6 c-1.6,0.2-3.4,1.2-4.5,2.4c-0.6,0.7-1.6,1.9-0.6,2.6C289.2,112.7,290.1,112.6,290.6,112.5z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.2,123.4c-1.5-5.7-8.8-10.9-14.9-11.2c-0.2,0-0.6,0.3,0.2,0.5c2.8,0.6,5.3,1.5,7.7,3.2 c2.8,2,5.5,4.7,6.7,7.9C314.2,124.5,314.4,124.1,314.2,123.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.6919,
    y1: 219.9746,
    x2: 326.6971,
    y2: 219.9746,
    gradientTransform: "matrix(0.5505 0.8348 -0.8348 0.5505 313.6342 -157.5542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#85431E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#693816"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M278.8,201.6c0,0-0.7,17.8,14,27.8c14.7,9.9,27.7-0.2,27.7-0.2L278.8,201.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.4863,
    y1: 212.7431,
    x2: 325.3419,
    y2: 213.5804,
    gradientTransform: "matrix(0.5505 0.8348 -0.8348 0.5505 313.6342 -157.5542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFB271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08876878,
    style: {
      stopColor: "#EFA362"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2366,
    style: {
      stopColor: "#DA8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3831,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5258,
    style: {
      stopColor: "#CA7F41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    style: {
      stopColor: "#CE8345"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7867,
    style: {
      stopColor: "#DB8F50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9209,
    style: {
      stopColor: "#EFA363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB271"
    }
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M315.5,201.5c-6.8-11.8-14-8.2-19.2-9c-10.4-1.6-15.9-2.3-17.3,3.5c-0.8,3.7-0.9,13.8,8.4,23.9 c9.3,10.1,19.1,11.3,28.8,9.7C325.9,228.1,322.9,214.3,315.5,201.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.0168,
    y1: 211.6982,
    x2: 326.8028,
    y2: 211.6982,
    gradientTransform: "matrix(0.5505 0.8348 -0.8348 0.5505 313.6342 -157.5542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C46E33"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1702,
    style: {
      stopColor: "#B15D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3529,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#A55228"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#B25D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C46E33"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M323.8,223.3c0.2-3.4-1.2-6.9-2.3-10c-1.2-3.6-2.7-7.1-4.3-10.5c-2.8-5.5-6.7-10.3-13.2-10.2 c7,1.7,10.2,6.6,12.7,12c2.4,5.2,5.1,11,5.5,16.7c0.6,7.5-6.8,8.8-12.6,8.6c-2.6-0.1-4.9-0.4-7.4-1.1c-3-0.9-5.6-2.4-8.4-3.7 c-0.4-0.2-0.8,0.4-0.4,0.7c5,4,13.1,5.9,19.4,5.7C318.3,231.2,323.5,229.4,323.8,223.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.7669,
    y1: 217.6291,
    x2: 315.7641,
    y2: 217.6291,
    gradientTransform: "matrix(0.5505 0.8348 -0.8348 0.5505 313.6342 -157.5542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#934B15"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07362485,
    style: {
      stopColor: "#934515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3052,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5309,
    style: {
      stopColor: "#933515"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    style: {
      stopColor: "#933915"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.936,
    style: {
      stopColor: "#934615"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#934B15"
    }
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M311.9,221.5c1.7-2-1.1-4.6-2.9-5.7c-3.8-2.4-7.7-4.3-11.3-7.1c-1.6-1.3-3.2-2.7-4.7-4.1 c-1.2-1.1-2.3-2.6-3.7-3.5c-2.1-1.2-4.5-0.5-5.6,1.6c-1.4,2.7-0.1,6,1.3,8.4c3.6,6.4,9.2,10.5,16,12.6 C303.7,224.5,309.2,224.7,311.9,221.5z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M293.3,226c4.4-3.5,8.8-7.8,11.7-12.6c-6.6-3.8-11.6-8.5-11.6-8.5s-6.5,1.5-9.3,2.2c-1.6,0.5-6.5,2.2-7.9,3 c-0.1,1.4-0.4,5.3-0.1,6.8c0.6,2.7,2.1,4.8,3.9,6.9c2.2,2.5,6.3,4.3,9.9,5.2C290.1,227.6,292.5,226.6,293.3,226z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.8,229.4c2.5-0.7,4.6-4,6.3-5.9c2.4-2.8,5.3-6.4,7.3-9.4c-0.5-0.2-0.9-0.5-1.4-0.8 c-3,4.8-7.4,9.1-11.7,12.6c-0.8,0.7-3.2,1.7-3.3,3C291,229.1,291.9,229.3,292.8,229.4z"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M305.2,211c0,0-1-0.6-1-0.6c-3.3,6.5-10.1,11.2-16.1,15c-0.2,0.2-0.1,1.5,0.2,1.3 C291.8,225.4,302.9,216,305.2,211z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M299.2,204.8c-5.8,0.7-14.6,3.1-19.5,6.5c4.1-1.6,15.3-5,18.3-5.7C298,205.6,299.2,204.8,299.2,204.8z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M292.2,208.9c-5.3,1.6-10.6,3.9-14.8,7.5c-0.4,0.3,0.2,0.9,0.6,0.6C282.6,214,287,211.8,292.2,208.9z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M300.6,213.5c0.2-0.5,0.1-0.5-0.2-0.2c-2,2.5-4.5,4.4-7.1,6.3c-2.3,1.7-5,2.9-7.4,4.5 c-0.2,0.1,0,0.4,0.2,0.4C291.9,223.2,298.1,218.6,300.6,213.5z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M295.6,209.1c-1.4,0.5-3.2,1.2-4.3,2.1c-0.2,0.1-0.1,0.5,0.2,0.4c1.4-0.6,3-1.4,4.3-2.2 C296.3,209.1,296.1,209,295.6,209.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.9652,
    y1: 238.9735,
    x2: 298.9652,
    y2: 229.3624,
    gradientTransform: "matrix(0.5505 0.8348 -0.8348 0.5505 313.6342 -157.5542)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A14E27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7608,
    style: {
      stopColor: "#C3652B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9897,
    style: {
      stopColor: "#CE6D2C"
    }
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M276.3,210.1c0,0,7.5,6,11.2,9.9c3.7,3.8,5.3,9.5,5.3,9.5s-6.7,1.5-13.2-5.1 C273.1,217.8,276.3,210.1,276.3,210.1z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M314.9,222.4c4.9-4.5-4.5-10.2-7.6-12.3c-3.4-2.2-6.7-4.6-9.6-7.4c-2.1-2-3.8-3.6-6.8-3.9 c-2.4-0.2-5.4,0.1-7,2.1c-1.5,1.9-1.3,4.3-0.7,6.5c0.2-0.1,0.6-0.2,0.7-0.2c-0.3-2-0.4-4.1,0.8-5.5c3.6-2.8,8.1,3.1,10.7,5.2 c2.6,2.1,5.4,4,8.2,5.8c2.8,1.8,11.7,5.7,6.5,9.8c-2.8,2.2-7.1,1.1-10.3,0.3c-0.1,0.2-0.5,0.5-0.8,0.9c2.7,1.1,5.5,1.4,8.4,1.2 C309.8,224.6,313,224.1,314.9,222.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M319.7,224.4c0-0.1-0.1-0.2-0.2-0.1c-1.1,1.1-2,2.2-3.5,2.7c-1.2,0.4-2.4,0.6-3.6,0.7c-0.5,0-0.4,0.4,0,0.5 C315,228.8,319.1,227.3,319.7,224.4z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M299.7,194c-1.2-0.1-2.5-0.1-3.6-0.1c-2.1-0.1-3.9-0.3-5.9-0.8c-0.5-0.1-0.7,0.1-0.3,0.4 c1.5,0.9,3.3,1.2,5,1.3c1.4,0.1,3.3,0,4.7-0.3C300,194.3,300.3,194,299.7,194z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M296.6,196c-0.8,0-2.3-0.1-3.5-0.2c-0.2,0-0.3,0.3-0.1,0.5c1,0.5,2.6,0.6,3.6,0.2 C296.8,196.3,296.8,196,296.6,196z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M311.2,228c-0.3-0.1-1.5-0.2-1.8-0.1c-0.1,0-0.1,0.2,0,0.3c0.4,0.3,1.4,0.3,1.8,0 C311.3,228.1,311.3,228,311.2,228z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushrooms);
export default __webpack_public_path__ + "static/media/mushrooms.6ea512c7f077ca857d1d7e4577aeabda.svg";
export { ForwardRef as ReactComponent };